// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___1LWFR","skeleton-loading":"styles__skeleton-loading___2x719","skeleton-loader-gradient":"styles__skeleton-loader-gradient___2LQwc","table":"styles__table___3Urmv","skeletonText":"styles__skeletonText___Fm3sO","tableHeader":"styles__tableHeader___1E7bD","itemValue":"styles__itemValue___23lXO","itemsClasses":"styles__itemsClasses___3NoAN","tableBody":"styles__tableBody___3A4dc","button":"styles__button___3Jko7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/PrePaidDocumentsSkeleton/styles.css
// module id = 3240
// module chunks = 0